"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicationIn = void 0;
class ApplicationIn {
    constructor() {
    }
    static getAttributeTypeMap() {
        return ApplicationIn.attributeTypeMap;
    }
}
exports.ApplicationIn = ApplicationIn;
ApplicationIn.discriminator = undefined;
ApplicationIn.attributeTypeMap = [
    {
        "name": "metadata",
        "baseName": "metadata",
        "type": "{ [key: string]: string; }",
        "format": ""
    },
    {
        "name": "name",
        "baseName": "name",
        "type": "string",
        "format": ""
    },
    {
        "name": "rateLimit",
        "baseName": "rateLimit",
        "type": "number",
        "format": "uint16"
    },
    {
        "name": "uid",
        "baseName": "uid",
        "type": "string",
        "format": ""
    }
];
//# sourceMappingURL=ApplicationIn.js.map